import React from 'react';

import { SEARCH_TERM_PREFIX } from '../constants/copy';
import * as styles from '../styles';

export interface SearchHeaderProps {
  searchTerm: string;
}

export const SearchHeader = ({ searchTerm }: SearchHeaderProps) => (
  <h1 css={styles.searchHeaderWrapper}>
    <span css={styles.termPrefix}>{SEARCH_TERM_PREFIX}</span>
    <span css={styles.term}>{searchTerm}</span>
  </h1>
);
